var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"host",staticClass:"safe-dv-charts"},[(_vm.ready)?_c('dv-charts-native',{ref:"charts",attrs:{"option":_vm.normalizedOption}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }